<sc-icon class="icon" size="1_5" icon="{{ item.icon }}"></sc-icon>
<div class="item">
  <span class="item__label">{{ item.description }}</span>
  <sc-progress-bar *ngIf="isLoading" class="item__progress-bar" >
  </sc-progress-bar>
  <span *ngIf="errorMessage" class="item__label item__label--error">
    {{ errorMessage }}
  </span>
</div>
<button
  *ngIf="isLoading"
  class="cancel-button"
  @fadeInOut
  [id]="'cancel-download-' + item.getIdentifier()"
  (click)="cancel($event)">
  <sc-icon icon="close" size="0_5"></sc-icon>
</button>
